'use client';

import { LandingHeader } from '@/components/landing/header';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import Image from "next/image"

const helpOptions = [
  {
    icon: '/documentation.svg',
    title: 'Documentation',
    description:
      'Master the Rudrise editor with our detailed guides, LaTeX tutorials, and API references.',
    link: '/documentation',
    buttonText: 'Browse Docs',
  },
  {
    icon: '/documentation.svg',
    title: 'Project Settings JSON',
    description:
      'Learn the project.rudra.config.json fields, types, and valid example used by every LaTeX project.',
    link: '/help/project-setting-json-schema',
    buttonText: 'Open Guide',
  },
  {
    icon: '/bug-report.svg',
    title: 'Bug Report',
    description:
      'Encountered a glitch? Submit a report to help us improve the reliability of the editor for everyone.',
    link: '/bug-report',
    buttonText: 'Report an Issue',
  },
  {
    icon: '/contact-us.svg',
    title: 'Contact Us',
    description:
      "Can't find an answer? Reach out directly to our support team for personalized assistance.",
    link: '/contact-us',
    buttonText: 'Email Support',
  },
    {
        icon: '/openTicket.svg',
        title: 'Open a Ticket',
        description:
            'Need immediate assistance or have complex issues? Open a support ticket for priority help.',
        buttonText: 'Create Ticket',
        link: '/support-tickets',
        grayscale: true,
    },
];

export default function HelpPage() {
  return (
    <>
      <main>
        <section className="bg-background py-16 md:py-24 px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                How can we <span className="text-primary">help you</span> today?
              </h1>
              <p className="text-lg text-muted-foreground">
                Find documentation, report issues, or get in touch with our team.
              </p>
            </div>

            {/* Help Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {helpOptions.map((option, idx) => (
                <Link
                  key={idx}
                  href={option.link}
                  className={`border border-border rounded-lg p-6 hover:shadow-md hover:border-primary/30  ${option.grayscale ? 'opacity-50' : ''}`}
                >
                  <Image
                                                              src={option.icon}
                                                              alt={`${option.title} Icon`}
                                                              width={64}
                                                              height={64}
                                                              className="mx-auto mb-4 object-contain"
                                                          />
                  <h3 className="text-xl font-bold mb-2">{option.title}</h3>
                  <p className="text-muted-foreground text-sm mb-6">
                    {option.description}
                  </p>
                  <Button variant="outline" size="sm" className="w-full gap-1" disabled={option.grayscale}>
                    {option.buttonText}
                    <span className="text-xs">→</span>
                  </Button>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
